export default "__VITE_ASSET__CwBl5R71__"